/**
 * VueX module for interacting with Metrics related data
 */
export default {
    state: {
        metrics: {}
    },

    getters: {
        metrics: state => state.metrics
    },

    mutations: {
        setMetrics(state, metrics) {
            state.metrics = metrics;
        }
    }
}